import { TemplateOutputs } from 'Features/Projects/Scenarios/Templates/TemplateResults/TemplateResults.types'
import { Box } from '@mui/material'
import { BaseTable } from 'Features/Projects/Table/BaseTable.view'
import { GridColDef } from '@mui/x-data-grid-premium'
import { useMemo } from 'react'

type DetailsTableProps = {
  data: TemplateOutputs[]
  isLoading: boolean
}

export const DetailsTable = ({ data, isLoading }: DetailsTableProps) => {
  const COLUMN_WIDTH = 150

  const templateOutputsColumns: GridColDef[] = useMemo(() => {
    return [
      {
        field: 'skuGroupCode',
        headerName: 'SKU Group Code',
        width: COLUMN_WIDTH,
        type: 'string',
      },
      {
        field: 'skuGroupName',
        headerName: 'SKU Group Name',
        width: COLUMN_WIDTH,
        type: 'string',
      },
      {
        field: 'batchGroupingCode',
        headerName: 'Batch Grouping Code',
        width: COLUMN_WIDTH,
        type: 'string',
      },
      {
        field: 'baseSourceSiteCode',
        headerName: 'Base Source Site Code',
        width: COLUMN_WIDTH,
        type: 'string',
      },
      { field: 'FOQ', headerName: 'FOQ', width: COLUMN_WIDTH, type: 'boolean' },
      {
        field: 'minimumCycle',
        headerName: 'Minimum Cycle',
        width: COLUMN_WIDTH,
        type: 'number',
      },
      {
        field: 'maximumCycle',
        headerName: 'Maximum Cycle',
        width: COLUMN_WIDTH,
        type: 'number',
      },
      {
        field: 'minimumProductionOrderQuantity',
        headerName: 'Min Production Order Quantity',
        width: COLUMN_WIDTH,
        type: 'number',
      },
      {
        field: 'minimumProductionOrderIncrement',
        headerName: 'Min Production Order Increment',
        width: COLUMN_WIDTH,
        type: 'number',
      },
      {
        field: 'salesRate',
        headerName: 'Sales Rate',
        width: COLUMN_WIDTH,
        type: 'number',
      },
      {
        field: 'skuGroupKey',
        headerName: 'SKU Group Key',
        width: COLUMN_WIDTH,
        type: 'number',
      },
      {
        field: 'isIncluded',
        headerName: 'Is Included',
        width: COLUMN_WIDTH,
        type: 'boolean',
      },
      {
        field: 'runRate',
        headerName: 'Run Rate',
        width: COLUMN_WIDTH,
        type: 'number',
      },
      {
        field: 'costPerUnit',
        headerName: 'Cost Per Unit',
        width: COLUMN_WIDTH,
        type: 'number',
      },
      {
        field: 'carbonCostPerUnit',
        headerName: 'Carbon Cost Per Unit',
        width: COLUMN_WIDTH,
        type: 'number',
      },
      {
        field: 'replenishmentTypeKey',
        headerName: 'Replenishment Type Key',
        width: COLUMN_WIDTH,
        type: 'number',
      },
      {
        field: 'replenishmentTypeCode',
        headerName: 'Replenishment Type Code',
        width: COLUMN_WIDTH,
        type: 'string',
      },
      {
        field: 'unitOfMeasureKey',
        headerName: 'Unit Of Measure Key',
        width: COLUMN_WIDTH,
        type: 'number',
      },
      {
        field: 'unitOfMeasureCode',
        headerName: 'Unit Of Measure Code',
        width: COLUMN_WIDTH,
        type: 'string',
      },
      {
        field: 'cycleTime',
        headerName: 'Cycle Time',
        width: COLUMN_WIDTH,
        type: 'number',
      },
      {
        field: 'batchCycle',
        headerName: 'Batch Cycle',
        width: COLUMN_WIDTH,
        type: 'number',
      },
      {
        field: 'batchStartWeek',
        headerName: 'Batch Start Week',
        width: COLUMN_WIDTH,
        type: 'number',
      },
      {
        field: 'weekNo',
        headerName: 'Week No',
        width: COLUMN_WIDTH,
        type: 'number',
      },
      {
        field: 'productionSequence',
        headerName: 'Production Sequence',
        width: COLUMN_WIDTH,
        type: 'number',
      },
      {
        field: 'changeOverTimeInHours',
        headerName: 'Changeover Time (hrs)',
        width: COLUMN_WIDTH,
        type: 'number',
      },
      {
        field: 'inBatchChangeOverTimeInHours',
        headerName: 'In-batch Changeover Time (hrs)',
        width: COLUMN_WIDTH,
        type: 'number',
      },
      {
        field: 'productionAmount',
        headerName: 'Production Amount',
        width: COLUMN_WIDTH,
        type: 'number',
      },
      {
        field: 'productionTimeInHrs',
        headerName: 'Production Time (hrs)',
        width: COLUMN_WIDTH,
        type: 'number',
      },
      {
        field: 'workcentreCode',
        headerName: 'Work Centre Code',
        width: COLUMN_WIDTH,
        type: 'string',
      },
    ]
  }, [data])

  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        overflow: 'auto',
        flexDirection: 'column',
      }}
    >
      <BaseTable
        data={data}
        columns={templateOutputsColumns}
        isLoading={isLoading}
        updateTableData={() => {}}
        uploadData={() => {}}
        isUploading={false}
        isSaving={false}
      />
    </Box>
  )
}
